<template>
    <the-dropdown
        v-if="$store.getters[filter.getter]"
        :selected-option="(filter.value || '').toString()"
        :text="filter.text"
        :options="$store.getters[filter.getter]"
        @onChange="$emit('set-filter', $event)"
    />
</template>

<script>
import filterMixin from './filter.mixin'

export default {
    mixins: [filterMixin]
}
</script>